<script setup>
 import ArgonButton from "@/components/ArgonButton.vue";

const Categories = defineModel();

const props = defineProps({
    builders: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits([
    'builder-changed'
]);
function changeBuilder(categoryId,builderName) {
    emit('builder-changed', {
       categoryId,
       builderName
    });
}

</script>
<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center">
            <h6 class="mb-0">Product Categories :</h6>
            <!-- <argon-button color="dark" variant="gradient"  size="sm" class="ms-auto" @click="$router.push('/product')"><i class="fas fa-plus me-2"></i>Add New Product </argon-button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Id</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Name</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Published</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Product Count</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Min Price</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Max Price</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Avg Price</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Builder</th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="item in Categories" :key="item.Id"> 
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ item.Id }}</p>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ item.Name }}</p>
                <p class="text-xs text-secondary mb-0"> {{ item.Path}}</p>
              </td>
              <td>
                <span class="badge badge-sm bg-gradient-success" v-if="item.Published">Published</span>
                <span class="badge badge-sm bg-gradient-warning" v-else>Not Published</span>
                <br/>
                <span class="badge badge-sm bg-gradient-danger" v-if="item.Deleted">Deleted</span>
                <!-- <span class="badge badge-sm bg-gradient-secondary" v-else>Not Deleted</span> -->
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ item.ProductCount }}</p>
              </td>
              <td>
                 <p class="text-xs font-weight-bold mb-0">{{ item.MinPrice }}</p>
              </td>
              <td>
                 <p class="text-xs font-weight-bold mb-0">{{ item.MaxPrice }}</p>
              </td>
              <td>
                 <p class="text-xs font-weight-bold mb-0">{{ item.AvgPrice }}</p>
                
              </td>
              <td>
                <select
                    class="form-select form-select-sm"
                    v-model="item.BuilderName"
                    @change="changeBuilder(item.Id,item.BuilderName)"
                >
                    <option :value="null"></option>

                    <option
                        v-for="builder in props.builders"
                        :key="builder"
                        :value="builder"
                    >
                        {{ builder}}
                    </option>
                </select>
              </td>
              <td>
                <a
                  :href="'/products?categoryId='+item.Id"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Edit user"
                  v-if="item.ProductCount>0">
                  <argon-button color="success" size="sm" variant="outline">Products</argon-button>
                </a>
                <!-- <a class="btn btn-link text-danger text-gradient px-3 mb-0" :href="'/products?categoryId='+item.Id"><i class="far fa-trash-alt me-2" aria-hidden="true"></i>Delete</a> -->
                <!-- <a class="btn btn-link text-dark px-3 mb-0" :href="'/products?categoryId='+item.Id"><i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i>Products</a> -->
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

